import { Injectable, inject } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { BottomSheetCardComponent } from './components/bottom-sheet/bottom-sheet.component';
import { CasualTournamentEntity } from '@fantaz/shared/data-access/models';

@Injectable({ providedIn: 'root' })
export class GameCardService {
  #bottomSheet: MatBottomSheet = inject(MatBottomSheet);
  #ref = new Map<String, MatBottomSheetRef<BottomSheetCardComponent>>();

  show(data: any) {
    this.#ref.set(
      data.tournament.uuid,
      this.#bottomSheet.open(BottomSheetCardComponent, {
        data,
        panelClass: 'game-card-bottom-sheet',
      }),
    );
  }

  close(tournament: CasualTournamentEntity) {
    const ref = this.#ref.get(tournament.uuid);
    if (ref) {
      ref.dismiss(tournament);
    }
  }
}
